import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IUploadLogFilterFieldsFragment = {
  id?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  version?: number | null
  projectId: any
  name: string
  userId?: any | null
  isPublic: boolean
  defaultForUsers?: Array<any | null> | null
  groupBy?: string | null
  filtersByFilterType?: Array<{
    type?: Types.UploadLogFilterType | null
    values?: Array<string | null> | null
  } | null> | null
}

export type IGetUploadLogCustomFiltersByProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGetUploadLogCustomFiltersByProjectQuery = {
  uploadLogCustomFilters?: {
    data: Array<{
      id?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      version?: number | null
      projectId: any
      name: string
      userId?: any | null
      isPublic: boolean
      defaultForUsers?: Array<any | null> | null
      groupBy?: string | null
      filtersByFilterType?: Array<{
        type?: Types.UploadLogFilterType | null
        values?: Array<string | null> | null
      } | null> | null
    }>
  } | null
}

export type ISaveUploadLogCustomFilterMutationVariables = Types.Exact<{
  filter: Types.IUploadLogCustomFilterInput
}>

export type ISaveUploadLogCustomFilterMutation = {
  saveUploadLogCustomFilter?: {
    id?: any | null
    createdAt?: any | null
    updatedAt?: any | null
    version?: number | null
    projectId: any
    name: string
    userId?: any | null
    isPublic: boolean
    defaultForUsers?: Array<any | null> | null
    groupBy?: string | null
    filtersByFilterType?: Array<{
      type?: Types.UploadLogFilterType | null
      values?: Array<string | null> | null
    } | null> | null
  } | null
}

export type IDeleteUploadLogCustomFilterMutationVariables = Types.Exact<{
  filterId: Types.Scalars['ObjectId']['input']
}>

export type IDeleteUploadLogCustomFilterMutation = {
  deleteUploadLogCustomFilter?: boolean | null
}

export const UploadLogFilterFieldsFragmentDoc = gql`
  fragment UploadLogFilterFields on UploadLogCustomFilter {
    id
    createdAt
    updatedAt
    version
    projectId
    name
    userId
    isPublic
    filtersByFilterType {
      type
      values
    }
    defaultForUsers
    groupBy
  }
`
export const GetUploadLogCustomFiltersByProjectDocument = gql`
  query GetUploadLogCustomFiltersByProject($projectId: ObjectId!) {
    uploadLogCustomFilters(limit: 1000000, projectId: $projectId) {
      data {
        ...UploadLogFilterFields
      }
    }
  }
  ${UploadLogFilterFieldsFragmentDoc}
`

/**
 * __useGetUploadLogCustomFiltersByProjectQuery__
 *
 * To run a query within a React component, call `useGetUploadLogCustomFiltersByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadLogCustomFiltersByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadLogCustomFiltersByProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetUploadLogCustomFiltersByProjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetUploadLogCustomFiltersByProjectQuery,
    IGetUploadLogCustomFiltersByProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetUploadLogCustomFiltersByProjectQuery,
    IGetUploadLogCustomFiltersByProjectQueryVariables
  >(GetUploadLogCustomFiltersByProjectDocument, options)
}
export function useGetUploadLogCustomFiltersByProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetUploadLogCustomFiltersByProjectQuery,
    IGetUploadLogCustomFiltersByProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetUploadLogCustomFiltersByProjectQuery,
    IGetUploadLogCustomFiltersByProjectQueryVariables
  >(GetUploadLogCustomFiltersByProjectDocument, options)
}
export type GetUploadLogCustomFiltersByProjectQueryHookResult = ReturnType<
  typeof useGetUploadLogCustomFiltersByProjectQuery
>
export type GetUploadLogCustomFiltersByProjectLazyQueryHookResult = ReturnType<
  typeof useGetUploadLogCustomFiltersByProjectLazyQuery
>
export type GetUploadLogCustomFiltersByProjectQueryResult = Apollo.QueryResult<
  IGetUploadLogCustomFiltersByProjectQuery,
  IGetUploadLogCustomFiltersByProjectQueryVariables
>
export const SaveUploadLogCustomFilterDocument = gql`
  mutation SaveUploadLogCustomFilter($filter: UploadLogCustomFilterInput!) {
    saveUploadLogCustomFilter(uploadLogCustomFilter: $filter) {
      ...UploadLogFilterFields
    }
  }
  ${UploadLogFilterFieldsFragmentDoc}
`
export type ISaveUploadLogCustomFilterMutationFn = Apollo.MutationFunction<
  ISaveUploadLogCustomFilterMutation,
  ISaveUploadLogCustomFilterMutationVariables
>

/**
 * __useSaveUploadLogCustomFilterMutation__
 *
 * To run a mutation, you first call `useSaveUploadLogCustomFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUploadLogCustomFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUploadLogCustomFilterMutation, { data, loading, error }] = useSaveUploadLogCustomFilterMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSaveUploadLogCustomFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveUploadLogCustomFilterMutation,
    ISaveUploadLogCustomFilterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveUploadLogCustomFilterMutation,
    ISaveUploadLogCustomFilterMutationVariables
  >(SaveUploadLogCustomFilterDocument, options)
}
export type SaveUploadLogCustomFilterMutationHookResult = ReturnType<
  typeof useSaveUploadLogCustomFilterMutation
>
export type SaveUploadLogCustomFilterMutationResult =
  Apollo.MutationResult<ISaveUploadLogCustomFilterMutation>
export type SaveUploadLogCustomFilterMutationOptions =
  Apollo.BaseMutationOptions<
    ISaveUploadLogCustomFilterMutation,
    ISaveUploadLogCustomFilterMutationVariables
  >
export const DeleteUploadLogCustomFilterDocument = gql`
  mutation DeleteUploadLogCustomFilter($filterId: ObjectId!) {
    deleteUploadLogCustomFilter(id: $filterId)
  }
`
export type IDeleteUploadLogCustomFilterMutationFn = Apollo.MutationFunction<
  IDeleteUploadLogCustomFilterMutation,
  IDeleteUploadLogCustomFilterMutationVariables
>

/**
 * __useDeleteUploadLogCustomFilterMutation__
 *
 * To run a mutation, you first call `useDeleteUploadLogCustomFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUploadLogCustomFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUploadLogCustomFilterMutation, { data, loading, error }] = useDeleteUploadLogCustomFilterMutation({
 *   variables: {
 *      filterId: // value for 'filterId'
 *   },
 * });
 */
export function useDeleteUploadLogCustomFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteUploadLogCustomFilterMutation,
    IDeleteUploadLogCustomFilterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteUploadLogCustomFilterMutation,
    IDeleteUploadLogCustomFilterMutationVariables
  >(DeleteUploadLogCustomFilterDocument, options)
}
export type DeleteUploadLogCustomFilterMutationHookResult = ReturnType<
  typeof useDeleteUploadLogCustomFilterMutation
>
export type DeleteUploadLogCustomFilterMutationResult =
  Apollo.MutationResult<IDeleteUploadLogCustomFilterMutation>
export type DeleteUploadLogCustomFilterMutationOptions =
  Apollo.BaseMutationOptions<
    IDeleteUploadLogCustomFilterMutation,
    IDeleteUploadLogCustomFilterMutationVariables
  >
